(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bbt-trust"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__bbTrust) return;
    window.__bbTrust = true;

    /* Edit this list to match where you really deliver. */
    var GURGAON_PINS = ['122001','122002','122003','122004','122005','122006','122007','122008','122009','122010','122011','122015','122016','122017','122018','122022','122051','122052','122101','122102','122103'];

    function get(k) { try { return localStorage.getItem(k) || ''; } catch (e) { return ''; } }
    function put(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
    function saveAttrs(a) {
      try { fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: a }), keepalive: true }).catch(function () {}); } catch (e) {}
    }

    function judge(root, pin) {
      var res = root.querySelector('[data-bt-res]');
      var eta = root.getAttribute('data-eta');
      res.className = 'bt-res';
      if (!/^[0-9]{6}$/.test(pin)) {
        res.textContent = 'Please enter a 6 digit pincode.'; res.classList.add('is-no'); return false;
      }
      if (GURGAON_PINS.indexOf(pin) > -1) {
        res.textContent = 'Yes, we deliver to ' + pin + '. Order today, with you by ' + eta + '.'; res.classList.add('is-ok'); return true;
      }
      if (pin.indexOf('122') === 0) {
        res.innerHTML = 'We are not sure we reach ' + pin + ' yet. <a href="/pages/contact">Message us</a> and we will confirm before you order.'; res.classList.add('is-no'); return true;
      }
      res.innerHTML = 'We only deliver in Gurgaon for now. <a href="/pages/contact">Tell us your pincode</a> and we will write when we reach you.'; res.classList.add('is-no');
      return true;
    }

    function applyPin(root, pin, remember) {
      var ok = judge(root, pin);
      if (!ok) return;
      if (remember) {
        put('bb_pin', pin);
        var hid = document.querySelector('[data-bt-pinval]');
        if (hid) { hid.value = pin; saveAttrs({ 'Pincode': pin }); }
      }
    }

    function hydrate() {
      document.querySelectorAll('[data-bt-eta]').forEach(function (root) {
        var input = root.querySelector('input[type=text]');
        var res = root.querySelector('[data-bt-res]');
        if (!input || !res || res.textContent) return;
        var pin = input.value || get('bb_pin');
        if (/^[0-9]{6}$/.test(pin)) { input.value = pin; judge(root, pin); }
      });
    }

    document.addEventListener('submit', function (e) {
      var f = e.target.closest && e.target.closest('[data-bt-pin]');
      if (!f) return;
      e.preventDefault();
      var root = f.closest('[data-bt-eta]');
      applyPin(root, f.querySelector('input').value.replace(/\s/g, ''), true);
    });
    document.addEventListener('input', function (e) {
      var t = e.target;
      if (t.closest && t.closest('[data-bt-pin]')) { t.value = t.value.replace(/[^0-9]/g, '').slice(0, 6); if (t.value.length === 6) applyPin(t.closest('[data-bt-eta]'), t.value, true); return; }
      var box = t.closest && t.closest('[data-bt-notify]');
      if (box && t.type === 'tel') {
        t.value = t.value.replace(/[^0-9]/g, '').slice(0, 10);
        var pv = box.querySelector('[data-bt-phoneval]'); pv.value = t.value;
        var er = box.querySelector('[data-bt-err]'); if (er) er.textContent = '';
        clearTimeout(box.__t); box.__t = setTimeout(function () { if (t.value.length === 10) { put('bb_phone', t.value); saveAttrs({ 'Notify phone': t.value }); } }, 500);
      }
    });
    document.addEventListener('click', function (e) {
      var chip = e.target.closest && e.target.closest('[data-bt-chip]');
      if (chip) {
        var box = chip.closest('[data-bt-notify]');
        var via = chip.getAttribute('data-bt-chip');
        box.querySelectorAll('[data-bt-chip]').forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        box.querySelector('[data-bt-via]').value = via;
        var needs = via !== 'Email';
        box.classList.toggle('has-phone', needs);
        var ph = box.querySelector('input[type=tel]');
        if (needs && ph && !ph.value && get('bb_phone')) { ph.value = get('bb_phone'); box.querySelector('[data-bt-phoneval]').value = ph.value; }
        var a = { 'Notify via': via }; if (ph && ph.value.length === 10) a['Notify phone'] = ph.value; saveAttrs(a);
        if (needs && ph && !ph.value) ph.focus();
        return;
      }
      var co = e.target.closest && e.target.closest('.cart__checkout-button, [name=checkout]');
      if (co) {
        var nb = document.querySelector('[data-bt-notify].has-phone');
        if (!nb) return;
        var p = nb.querySelector('input[type=tel]');
        if (p && !/^[0-9]{10}$/.test(p.value)) {
          e.preventDefault(); e.stopPropagation();
          var er2 = nb.querySelector('[data-bt-err]'); if (er2) er2.textContent = 'Add your 10 digit number, or choose Email only.';
          nb.scrollIntoView({ block: 'center', behavior: 'smooth' }); p.focus();
        }
      }
    }, true);

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hydrate); else hydrate();
    var t2; new MutationObserver(function () { clearTimeout(t2); t2 = setTimeout(hydrate, 120); }).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
